import React from 'react';
import { Placeholder, Card } from 'react-bootstrap';

const DashboardSkeleton: React.FC = () => (
  <div className="dashboard-page">
    <div className="dashboard-work-queue-section mb-4">
      <Placeholder animation="glow" className="mb-2">
        <Placeholder xs={4} />
      </Placeholder>
      <div className="dashboard-stats dashboard-stats--auto-fill">
        {[1, 2, 3].map((i) => (
          <div key={i} className="dashboard-stat-card">
            <Placeholder animation="glow" style={{ width: '100%' }}>
              <Placeholder xs={8} /> <Placeholder xs={6} />
            </Placeholder>
          </div>
        ))}
      </div>
    </div>
    <Card className="ntcog-card dashboard-section-card mb-4">
      <Card.Body>
        <Placeholder animation="glow">
          <Placeholder xs={12} /> <Placeholder xs={10} /> <Placeholder xs={11} />
        </Placeholder>
      </Card.Body>
    </Card>
  </div>
);

export default DashboardSkeleton;
